import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { MastheadPortalId } from '../../../../models/AdminModels';
import { useAdminAccountQuery } from '../../../../queries/Admin/Account/useAdminAccountQuery';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { NavigationBreadcrumbsBar } from '../../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../../web/components/Portal';
import { AdminAPIKeys } from '../../../components/integrations/AdminAPIKeys';
import { AdminDashboardPageLayout } from '../../AdminDashboardPageLayout';

interface IRouteParams {
	accountId: string;
}

const _AdminAPIKeysPage = () => {
	const { accountId } = useParams<IRouteParams>();

	const accountQuery = useAdminAccountQuery({
		enabled: !!accountId,
		accountId: accountId || '',
		meta: {
			toastErrorMessage: 'Error loading account',
		},
	});

	const pathComponentNameProvider = useCallback(
		(pathComponent: string) => {
			if (accountQuery.data?.id === pathComponent) {
				return accountQuery.data?.companyName;
			}
			return pathComponent ? `${pathComponent[0].toLocaleUpperCase()}${pathComponent.substring(1)}` : pathComponent;
		},
		[accountQuery.data?.companyName, accountQuery.data?.id]
	);

	if (!accountId) {
		return <div>No account ID provided</div>;
	}

	if (accountQuery.isPending) {
		return (
			<AdminDashboardPageLayout>
				<LoadingSpinner type='large' />
			</AdminDashboardPageLayout>
		);
	}

	return (
		<AdminDashboardPageLayout>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar
					currentLocationName='API Keys'
					pathComponentNameProvider={pathComponentNameProvider}
				/>
			</Portal>

			<div style={{ padding: '20px' }}>
				<AdminAPIKeys accountID={accountId} />
			</div>
		</AdminDashboardPageLayout>
	);
};

export const AdminAPIKeysPage = observer(_AdminAPIKeysPage);
